import React from 'react'
import { PageSection, TextContent, Text, PageSectionVariants, TabTitleText, Tabs, Tab, TabContent, TabContentBody } from '@patternfly/react-core'
import { ListProducts } from './Products/ListProducts'
import { ListFormulations } from './Formulations/ListFormulations'
import { ListIngredients } from './Ingredients/ListIngredients'
import { useHistory, useParams } from 'react-router-dom'

const ProductHome: React.FunctionComponent = () => {
  // fixed data
  const history = useHistory()
  const pathParams = useParams()
  const sections = ['main', 'formulations', 'ingredients']
  const { section } = pathParams as Record<string, string | undefined>

  const startTabKey = sections.includes(section || '') ? section : sections[0]

  // reactive data
  const [activeTabKey, setActiveTabKey] = React.useState(startTabKey)

  // Toggle currently active tab
  const handleTabClick = (tabKey: string) => {
    setActiveTabKey(tabKey)
    history.push(`/product/${tabKey}`)
  }

  return (
    <React.Fragment>
      <PageSection variant={PageSectionVariants.light}>
        <TextContent>
          <Text component="h1">Products</Text>
          <Text component="p">Product & ingredient management</Text>
        </TextContent>
      </PageSection>
      <PageSection type="tabs">
        <Tabs mountOnEnter activeKey={activeTabKey} onSelect={(_event, tabKey) => handleTabClick(String(tabKey))} usePageInsets id="nested-tabs-list" isBox>
          <Tab eventKey={sections[0]} title={<TabTitleText>Products</TabTitleText>} tabContentId={`tabContent${0}`}>
            <TabContent id={`tabContent${0}`}>
              <TabContentBody hasPadding children={<ListProducts></ListProducts>}></TabContentBody>
            </TabContent>
          </Tab>
          <Tab eventKey={sections[1]} title={<TabTitleText>Formulations</TabTitleText>} tabContentId={`tabContent${1}`}>
            <TabContent id={`tabContent${1}`}>
              <TabContentBody hasPadding children={<ListFormulations></ListFormulations>}></TabContentBody>
            </TabContent>
          </Tab>
          <Tab eventKey={sections[2]} title={<TabTitleText>Ingredients</TabTitleText>} tabContentId={`tabContent${2}`}>
            <TabContent id={`tabContent${2}`}>
              <TabContentBody hasPadding children={<ListIngredients></ListIngredients>}></TabContentBody>
            </TabContent>
          </Tab>
        </Tabs>
      </PageSection>
    </React.Fragment>
  )
}

export { ProductHome }
